import { useMemo } from 'react';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';

/**
 * siteNumber 에 따른 컴포넌트 반환 훅
 *
 * @param {*} defaultPage : React.ComponentType
 * @param {*} sitePageMap : { "SiteNumber": React.ComponentType } 키가 siteNumber, 벨류가 컴포넌트인 오브젝트
 * @returns React.ComponentType
 */
export function useSiteComponentResolver(defaultPage, sitePageMap, isEventMall = false, multiMallMyPageLnbMenuItems) {
  const { siteNumber } = useSiteInfo();

  return useMemo(() => {
    if (isEventMall) {
      return multiMallMyPageLnbMenuItems;
    } else {
      return sitePageMap[siteNumber] || defaultPage;
    }
  }, [defaultPage, isEventMall, multiMallMyPageLnbMenuItems, siteNumber, sitePageMap]);
}
